import { LssProp } from '@lucidhq/lucidium';

import { Status } from '@/components';

export enum PaymentMethodsStatusEnum {
  active = 'active',
  deactivated = 'deactivated',
}

export const PaymentMethodsStatusMap = {
  [PaymentMethodsStatusEnum.active]: 'Active',
  [PaymentMethodsStatusEnum.deactivated]: 'Deactivated',
} as const;

const PaymentMethodsColorMap: Record<PaymentMethodsStatusEnum, LssProp> = {
  [PaymentMethodsStatusEnum.active]: {
    borderColor: 'success400',
    bg: 'success100',
  },
  [PaymentMethodsStatusEnum.deactivated]: {
    borderColor: 'danger400',
    bg: 'danger100',
  },
};

export type PaymentMethodsStatusType = keyof typeof PaymentMethodsStatusMap;

export interface PaymentMethodsStatusProps {
  status: PaymentMethodsStatusType;
}

export const PaymentMethodsStatus = ({ status }: PaymentMethodsStatusProps) => (
  <Status
    status={status}
    colorMap={PaymentMethodsColorMap}
    statusMap={PaymentMethodsStatusMap}
    width="95px"
  />
);
